import { render, staticRenderFns } from "./AxSelectNative.vue?vue&type=template&id=35e25554&scoped=true&"
import script from "./AxSelectNative.vue?vue&type=script&lang=ts&"
export * from "./AxSelectNative.vue?vue&type=script&lang=ts&"
import style0 from "./AxSelectNative.vue?vue&type=style&index=0&id=35e25554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e25554",
  null
  
)

export default component.exports